"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInternalSlots = getInternalSlots;
var internalSlotMap = new WeakMap();
function getInternalSlots(x) {
    var internalSlots = internalSlotMap.get(x);
    if (!internalSlots) {
        internalSlots = Object.create(null);
        internalSlotMap.set(x, internalSlots);
    }
    return internalSlots;
}
